export default {
    regular_invoice: {
        id: 1,
        name: "Regular Invoice",
    },
    credit_note: {
        id: 2,
        name: "Credit Note",
    },
};